import axios from 'axios';
import { hashHistory } from 'react-router';

import url from '../../components/common/BaseURL';

const baseURL = url.baseURL;

export const articleTextChange = (articleText) => {
    return {
        type: 'ARTICLE_TEXT_CHANGE',
        payload: articleText
    };
};

export const fetchArticles = (user) => {
    return (dispatch) => {
        dispatch({ type: 'FETCH_ARTICLE' });
        axios.get(baseURL + 'articles', {
            params: {
                token: user.token,
                user_id: user.user_id
            }
        }).then(response => {
            console.log(response);
            dispatch({ type: 'FETCH_ARTICLE_SUCCESS', payload: response.data.data });
        }).catch(err => {
            dispatch({ type: 'FETCH_ARTICLE_FAIL' });
            console.log(err);
        });
    };
};

export const addArticle = (user, text) => {
    return (dispatch) => {
        dispatch({ type: 'ADD_ARTICLE' });
        axios.get(baseURL + 'articles/scrape', {
            params: {
                token: user.token,
                user_id: user.user_id,
                url: text
            }
        }).then(response => {
            console.log(response);
            dispatch({ type: 'ADD_ARTICLE_SUCCESS', payload: response.data.data });
            hashHistory.push("/articles/add_articles/push");
        }).catch(err => {
            dispatch({ type: 'ADD_ARTICLE_FAIL' });
            console.log(err);
        });
    };
};

export const articleTextClear = () => {
    return {
        type: 'ARTICLE_TEXT_CLEAR'
    };
};

export const articleTitleChange = (articleTitle) => {
    return {
        type: 'ARTICLE_TITLE_CHANGE',
        payload: articleTitle
    };
};

export const articleUrlChange = (articleUrl) => {
    return {
        type: 'ARTICLE_URL_CHANGE',
        payload: articleUrl
    };
};

export const articlePictureChange = (articlePicture) => {
    return {
        type: 'ARTICLE_PICTURE_CHANGE',
        payload: articlePicture
    };
};
export const incrementCounter = (counter) => {
    return {
        type: 'INCREMENT_COUNTER',
        payload: counter + 1
    };
};

export const clearCounter = () => {
    return {
        type: 'CLEAR_COUNTER',
        payload: 0
    };
};

export const saveArticle = (user, articleTitle, articleUrl, articlePicture) => {
    return (dispatch) => {
        dispatch({ type: 'SAVE_ARTICLE' });
        axios.post(baseURL + 'articles', {
            token: user.token,
            user_id: user.user_id,
            title: articleTitle,
            url: articleUrl,
            picture: articlePicture,
            push: false
        })
            .then((res) => {
                dispatch({ type: 'SAVE_ARTICLE_SUCCESS', payload: res });
                hashHistory.push("/articles");
            })
            .catch((error) => {
                dispatch({ type: 'SAVE_ARTICLE_FAIL' });
                console.log(error);
            });
    };
};

export const pushArticle = (user, articleTitle, articleUrl, articlePicture) => {
    return (dispatch) => {
        dispatch({ type: 'PUSH_ARTICLE' });
        axios.post(baseURL + 'articles', {
            token: user.token,
            user_id: user.user_id,
            title: articleTitle,
            url: articleUrl,
            picture: articlePicture,
            push: true
        })
            .then((res) => {
                dispatch({ type: 'PUSH_ARTICLE_SUCCESS', payload: res });
                hashHistory.push("/articles");
            })
            .catch((error) => {
                dispatch({ type: 'PUSH_ARTICLE_FAIL' });
                console.log(error);
            });
    };
};

export const fetchLoading = () => {
    return {
        type: 'LOADING_CHANGE',
        payload: false
    };
};




// WEBPACK FOOTER //
// ./src/actions/Articles/ArticleAction.js